import { setLocal, getLocal, removeLocal } from "@/utils/com";

const myKey = "etms_LogClientType_key";

export function setConfig(type) {
  var data = {
    logClientType: type
  };
  removeLocal(myKey);
  setLocal(myKey, data);
  window.etmsClient = data;
}

export function getConfig() {
  try {
    var obj = getLocal(myKey);
    if (obj) {
      return obj.logClientType;
    }
    if (window.etmsClient) {
      return window.etmsClient.logClientType;
    }
    return 1;
  } catch (e) {
    console.log(e);
    return 1;
  }
}



// WEBPACK FOOTER //
// ./src/utils/logClientType.js